import React, {Component} from 'react';

import {AppContext} from '../../../../../AppModule/Context';

import ToastComponent from '../../toastComponent/toastComponent';

import './toastWrapperComponentRender.css';

// const taostObj = {
//   idx,
//   isSticky,
//   toastId,
//   toastTitle,
//   toastType,
//   toastExtraData: {
//     progressBarInfo: {
//       percentage: 51,
//     },
//     toastSubTitleText: '',
//   },
//   onDismiss,
//   timeoutId,
// };

class ToastWrapperComponentRender extends Component {
  constructor(props) {
    super(props);
    this.toastRefs = {};
    this.spaceBetweenToasts = 10;
    this.initialBottomOffset = 50;
  }

  updateToastPositions = () => {
    const toastElementRefs = Object.values(this.toastRefs).filter(Boolean);

    let currentBottom = this.initialBottomOffset;
    [...toastElementRefs].forEach((toastElementRef) => {
      // Position this toast at the current bottom position
      toastElementRef.style.bottom = `${currentBottom}px`;

      // Get height and update position for next toast
      const height = toastElementRef.offsetHeight;
      currentBottom += height + this.spaceBetweenToasts;
    });
  };

  componentDidUpdate = () => {
    // Cancel any existing animation frame
    if (this.animationFrameTimeoutId) {
      cancelAnimationFrame(this.animationFrameTimeoutId);
    }
    // Update positions after render
    this.animationFrameTimeoutId = requestAnimationFrame(
      this.updateToastPositions,
    );
  };

  componentDidMount = () => {
    // Initial position update
    this.animationFrameTimeoutId = requestAnimationFrame(
      this.updateToastPositions,
    );
  };

  componentWillUnmount = () => {
    // Clean up animation frame when component unmounts
    if (this.animationFrameTimeoutId) {
      cancelAnimationFrame(this.animationFrameTimeoutId);
    }
  };

  render() {
    return (
      <div className="et-v2-toast-wrapper-container">
        {this.props.modifiedToastData.map(
          ({
            isSticky,
            toastId,
            toastTitle,
            toastType,
            toastExtraData,
            toastCustomBtnTxt,
            toastCustomBtnAction,
            toastLongDuration,
            onDismiss,
          }) => {
            return (
              <div
                key={toastId}
                ref={(element) => (this.toastRefs[toastId] = element)}
                className={`et-v2-toast-component-wrap ${toastLongDuration ? 'et-v2-toast-component-wrap-with-long-duration' : ''} ${isSticky ? 'et-v2-toast-component-wrap-sticky' : ''}`}>
                <ToastComponent
                  isSticky={isSticky}
                  toastExtraData={toastExtraData}
                  toastTitle={toastTitle}
                  toastType={toastType}
                  onDismiss={onDismiss}
                  toastCustomBtnTxt={toastCustomBtnTxt}
                  toastCustomBtnAction={toastCustomBtnAction}
                />
              </div>
            );
          },
        )}
      </div>
    );
  }
}

ToastWrapperComponentRender.contextType = AppContext;
export default ToastWrapperComponentRender;
